import { find, last, chain, pick, toLower } from "lodash"
import { createSelector } from "reselect"
import { getSelectedContributorCategoryId } from "helpers/compositeSecuritiesDetails"
import { computeFactorSensitivityData } from "helpers/factorSensitivity"
import { computeSelectedValue } from "helpers/contributors"

const getSelectedDate = (_, props) => props.selectedDate
const getAllCategoryItems = (_, props) => props.allCategoryItems
const getFactorSensitivity = (_, props) => props.factorSensitivity

export const getSelectedContributorCategory = createSelector(
  [getSelectedContributorCategoryId, getAllCategoryItems],
  (selectedId, categories) => {
    if (!selectedId) {
      return null
    }

    return find(categories, category => toLower(category.id) === toLower(selectedId))
  },
)

const getContributorData = createSelector(
  [getAllCategoryItems, getFactorSensitivity],
  computeFactorSensitivityData,
)

const getLastContributor = createSelector(
  [getContributorData],
  last,
)

export const getDetails = createSelector(
  [getContributorData, getSelectedDate, getAllCategoryItems, getLastContributor],
  (data, selectedDate, items, lastContributor) => {
    let dayData = {}

    if (lastContributor) {
      if (selectedDate === lastContributor.date.format("YYYY-MM-DD")) {
        dayData = lastContributor
      } else {
        const contributor = find(data, day => selectedDate === day.date.format("YYYY-MM-DD"))
        if (contributor) {
          dayData = contributor
        }
      }
    }

    return chain(items)
      .map(item => ({
        ...pick(item, ["label", "id", "color", "category", "favorite", "field", "isAggregated"]),
        value: dayData[item.id],
      }))
      .filter(item => item.value || item.favorite)
      .value()
  },
)

export const getSelectedContributorValue = createSelector(
  [getDetails, getSelectedContributorCategory],
  computeSelectedValue,
)
